import { render, staticRenderFns } from "./batchlist.vue?vue&type=template&id=2a94e8a0&scoped=true&"
import script from "./batchlist.vue?vue&type=script&lang=js&"
export * from "./batchlist.vue?vue&type=script&lang=js&"
import style0 from "./batchlist.vue?vue&type=style&index=0&id=2a94e8a0&lang=scss&scoped=true&"
import style1 from "./batchlist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a94e8a0",
  null
  
)

export default component.exports